import { useState, useEffect } from 'react';

// API base URL
const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api`;

// Custom hook to fetch trailers
export const useTrailers = () => {
  const [trailers, setTrailers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrailers = async () => {
      try {
        const response = await fetch(`${API_URL}/trailers`);
        const data = await response.json();
        
        if (data.success) {
          setTrailers(data.trailers);
        } else {
          setError('Failed to load trailers');
        }
      } catch (err) {
        setError('Error connecting to server');
        if (process.env.NODE_ENV === 'development') console.error('Error fetching trailers:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTrailers();
  }, []);

  return { trailers, loading, error };
};

// For backward compatibility, export static data as fallback
export const trailers = [];